<div class="orders-invoice mb-4" [formGroup]="parent">
  <header class="d-flex align-items-center justify-content-between pb-3">
    <h2 class="m-0">Invoice Email Address(es)</h2>
    <div class="d-flex justify-content-end gap-2 align-items-center">
      <a class="link-gray" (click)="newLine.emit(true)"
        ><i class="pi pi-plus"></i> Add new</a
      >
      <a class="link-gray delcol" (click)="onRemoveEmail()"
        ><i class="pi pi-trash"></i> Remove</a
      >
    </div>
  </header>
  <!-- <p-virtualscroller> -->
  <p-table
    #dt
    stripedRows
    [value]="invoicedEmails"
    styleClass="p-datatable-customers invoiceListing"
    [rowHover]="true"
    [size]="'small'"
    scrollHeight="300px"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="false"
    [filterDelay]="0"
    selectionMode="single"
    [(selection)]="emailSelected"
    styleClass="table-listing popuptable">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
        <th class="name">Name</th>
        <th class="purpose">Purpose</th>
        <th class="email">Email</th>
        <th class="save">Save</th>
        <th class="exist">Exist</th>
        <th class="confirmation">Confirmation</th>
        <th class="invoice">Invoice</th>
      </tr>
      <tr>
        <th></th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="value.name"
              id="value.name"
              (input)="
                dt.filter($any($event.target).value, 'value.name', 'contains')
              "
              placeholder=""
              class="p-column-filter" />
          </div>
        </th>
        <th></th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="value.email"
              id="value.email"
              (input)="
                dt.filter($any($event.target).value, 'value.email', 'contains')
              "
              placeholder=""
              class="p-column-filter" />
          </div>
        </th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-invoiceListing let-rowIndex="rowIndex">
      <ng-container formArrayName="invoicedEmails">
        <tr class="p-selectable-row" [formGroupName]="rowIndex">
          <td>
            <p-tableCheckbox [value]="invoiceListing"></p-tableCheckbox>
          </td>
          <td class="name">
            <input
              pInputText
              jniAutoCompleteBlocker
              class="form-control filter me-2"
              type="text"
              [value]="invoiceListing.value.name"
              formControlName="name" />
          </td>
          <td class="purpose">
            <input
              pInputText
              jniAutoCompleteBlocker
              class="form-control filter me-2"
              type="text"
              [value]="invoiceListing.value.purpose"
              formControlName="purpose" />
          </td>
          <td class="email">
            <input
              pInputText
              pInputText
              jniAutoCompleteBlocker
              class="form-control filter me-2"
              type="text"
              [value]="invoiceListing.value.email"
              formControlName="email" />
          </td>
          <td class="save">
            <p-checkBox
              type="checkbox"
              formControlName="save"
              inputId="save"
              binary="true" />
          </td>
          <td class="exist">
            <p-checkBox
              type="checkbox"
              formControlName="exist"
              inputId="exist" />
          </td>
          <td class="confirmation">
            <p-checkBox
              type="checkbox"
              formControlName="confirmation"
              binary="true" />
          </td>
          <td class="invoice">
            <p-checkBox
              type="checkbox"
              formControlName="invoiced"
              binary="true" />
          </td>
        </tr>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No Invoiced Email found.</td>
      </tr>
    </ng-template>
  </p-table>
  <!-- </p-virtualscroller> -->
</div>
